export default {
  productId(state) {
    return state.productId;
  },
  address(state) {
    return state.address;
  },
  personalInformation(state) {
    return state.personalInformation;
  },
  bankAccount(state) {
    return state.bankAccount;
  },
  fundSelection(state) {
    return state.fundSelection;
  },
  fundAllocation(state) {
    return state.fundAllocation;
  },
};
